(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('complementAirCrewsCtrl', complementAirCrewsCtrl)
        .controller('complementAirCrewNewCtrl', complementAirCrewNewCtrl)
        .controller('complementAirCrewEditCtrl', complementAirCrewEditCtrl)
        .controller('complementAirCrewDeleteCtrl', complementAirCrewDeleteCtrl)
        .controller('modalComplementAirCrewNewCtrl', modalComplementAirCrewNewCtrl);

    complementAirCrewsCtrl.$inject = ['linkService', 'complementAirCrews', 'tabAdminFlights'];

    complementAirCrewNewCtrl.$inject = ['linkService', 'tabAdminFlights','complementAirCrewService',
        'occupationComplementAirCrewList'];

    complementAirCrewEditCtrl.$inject = ['linkService', 'tabAdminFlights','complementAirCrew','complementAirCrewService',
        'occupationComplementAirCrewList', 'datePickerService','$stateParams','dateService'];

    complementAirCrewDeleteCtrl.$inject = ['$uibModalInstance','complementAirCrewService','$stateParams'];
    modalComplementAirCrewNewCtrl.$inject = ['linkService','complementAirCrewService','occupationComplementAirCrewList', '$uibModalInstance'];

    function complementAirCrewsCtrl(linkService, complementAirCrews, tabAdminFlights) {
        var vm = this;
        vm.pages = [];

        vm.tabs = tabAdminFlights;
        vm.linkService = linkService;
        vm.complementAirCrews = (complementAirCrews.data._embedded) ? complementAirCrews.data._embedded.aircrews : [];
        vm.pages = complementAirCrews.data.page;
    }

    function complementAirCrewNewCtrl(linkService, tabAdminFlights,complementAirCrewService, occupationComplementAirCrewList) {
        var vm = this;
        vm.tabs = tabAdminFlights;
        //vm.modelAircrafts = modelAirCrafts.data._embedded.modelAircrafts;
        vm.occupationComplementAirCrewList = (occupationComplementAirCrewList._embedded) ? occupationComplementAirCrewList._embedded.occupationCrews : [];
        vm.crew = {
            phones: [
                {
                    prefix : undefined,
                    number : undefined
                }
            ]
        };


        // CALENDAR ================================================================
        vm.datePickerOpenStatus = {
            'dateFrom': false
        };
        //vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: new Date()
            },
            closed: function(args) {
                var valueDate = args.closeDate;
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.changeHandler = function (form) {
            if(form.expirationDate.$modelValue != undefined && !isNaN(form.expirationDate.$modelValue)){
                form.expirationDate.$setValidity('dateHigherToday', vm.crew.expirationDate.getTime() >= vm.datepickerFrom.datepickerOptions.minDate.getTime());
            }else{
                form.expirationDate.$setValidity('date', false);
            }
        }
        // CALENDAR ================================================================

        vm.cancel = function () {
            linkService.reloadRoute('complementAirCrews', null);
        }

        vm.saveComplementAirCrew = function (isValid, complementAirCrew) {
            var save = {
                "name": complementAirCrew.name,
                "lastName": complementAirCrew.lastName,
                "nroIdentity": complementAirCrew.nroIdentity,
                "address": complementAirCrew.address,
                "phone": getPhone(complementAirCrew.phones),
                "license": complementAirCrew.license,
                "expirationDate": moment(complementAirCrew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": parseInt(linkService.getLinkId(complementAirCrew.charge._links.self.href)),
                "typeCrew": 2
            }
            if (isValid) {
                complementAirCrewService.saveComplementAirCrew(save);
            }
        }

        vm.addPhones = function(){
            vm.crew.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.crew.phones.splice(index, 1)
        }
    }

    function complementAirCrewEditCtrl(linkService,tabAdminFlights,complementAirCrew,complementAirCrewService,
                                       occupationComplementAirCrewList, datePickerService,$stateParams,dateService) {
        var vm = this;
        vm.complementAirCrew = complementAirCrew
        vm.tabs = tabAdminFlights;

        vm.cancel = function () {
            linkService.reloadRoute('complementAirCrews', null);
        }

        // CALENDAR ================================================================
        vm.datePickerOpenStatus = {
            'dateFrom': false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: new Date()
            },
            closed: function(args) {
                var valueDate = args.closeDate;
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.changeHandler = function (form) {
            if(form.expirationDate.$modelValue != undefined){
                form.expirationDate.$setValidity('dateHigherToday', vm.crew.expirationDate.getTime() >= vm.datepickerFrom.datepickerOptions.minDate.getTime());
            }else{
                form.expirationDate.$setValidity('date', false);
            }
        }
        // CALENDAR ================================================================

        vm.occupationComplementAirCrewList = [];
        vm.crew = {
            'charge': vm.complementAirCrew.occupationCrew,
            'name': vm.complementAirCrew.name,
            'lastName': vm.complementAirCrew.lastName,
            'nroIdentity': vm.complementAirCrew.nroIdentity,
            'address': vm.complementAirCrew.address,
            'phone': vm.complementAirCrew.phone,
            "phones": setPhones(vm.complementAirCrew.phone),
            'license': vm.complementAirCrew.license,
            'expirationDate': dateService.getDateByDateZone(vm.complementAirCrew.expirationDate)
        }

        vm.occupationComplementAirCrewList = occupationComplementAirCrewList._embedded.occupationCrews;
        vm.old = angular.copy(vm.crew);
        vm.buttonSave = true;

        vm.saveComplementAirCrew = function (isValid, complementAirCrew) {
            var save = {
                "name": complementAirCrew.name,
                "lastName": complementAirCrew.lastName,
                "nroIdentity": complementAirCrew.nroIdentity,
                "address": complementAirCrew.address,
                "phone": getPhone(complementAirCrew.phones),
                "license": complementAirCrew.license,
                "expirationDate": moment(complementAirCrew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": parseInt(complementAirCrew.charge.id),
                "typeCrew": 2
            }

            if (isValid) {
                complementAirCrewService.updateComplementAirCrew($stateParams.id, save);
            }
        }

        vm.change = function(){
            if( vm.crew.charge!=undefined && vm.crew.charge.name==vm.old.charge.name &&
                vm.crew.name.toUpperCase()==vm.old.name.toUpperCase() &&
                vm.crew.lastName.toUpperCase()==vm.old.lastName.toUpperCase() &&
                vm.crew.nroIdentity==vm.old.nroIdentity && vm.crew.address.toUpperCase()==vm.old.address.toUpperCase() &&
                getPhone(vm.crew.phones) == vm.old.phone && vm.crew.license==vm.old.license &&
                vm.crew.expirationDate!=undefined && vm.crew.expirationDate.getTime()==vm.old.expirationDate.getTime()){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }

        vm.addPhones = function(){
            vm.crew.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.crew.phones.splice(index, 1)
        }
    }

    function complementAirCrewDeleteCtrl($uibModalInstance, complementAirCrewService,$stateParams) {
        var vm = this;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.deleteOccupationCrew = function () {
            complementAirCrewService.deleteComplementAirCrew($stateParams.id)
                .then(function () {
                    $uibModalInstance.close(true);
                });
        }
    }

    function modalComplementAirCrewNewCtrl(linkService,complementAirCrewService, occupationComplementAirCrewList,$uibModalInstance) {
        var vm = this;
        vm.occupationComplementAirCrewList = occupationComplementAirCrewList._embedded.occupationCrews;
        vm.crew = {
            phones: [
                {
                    prefix : undefined,
                    number : undefined
                }
            ]
        };

        vm.datePickerOpenStatus = {
            'dateFrom': false
        };

        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: new Date()
            },
            closed: function(args) {
                var valueDate = args.closeDate;
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.changeHandler = function (form) {
            if(form.expirationDate.$modelValue != undefined){
                form.expirationDate.$setValidity('dateHigherToday', vm.crew.expirationDate.getTime() >= vm.datepickerFrom.datepickerOptions.minDate.getTime());
            }else{
                form.expirationDate.$setValidity('date', false);
            }
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.saveModalComplementAirCrew = function (isValid) {
            var save = {
                "name": vm.crew.name,
                "lastName": vm.crew.lastName,
                "nroIdentity": vm.crew.nroIdentity,
                "address": vm.crew.address,
                "phone": getPhone(vm.crew.phones),
                "license": vm.crew.license,
                "expirationDate": moment(vm.crew.expirationDate).format('YYYY-MM-DD'),
                "occupationCrewId": parseInt(linkService.getLinkId(vm.crew.charge._links.self.href)),
                "typeCrew": 2
            }
            if (isValid) {
                complementAirCrewService.saveAddComplementAirCrew(save).then(function(response) {
                    $uibModalInstance.close({airCrew: response.data, typeCrew: 2});
                });
            }
        }

        vm.addPhones = function(){
            vm.crew.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.crew.phones.splice(index, 1)
        }
    }

    function getPhone(phones){
        var res = '';
        angular.forEach(phones, function(phone){
            res = res+(res.length==0?'':',')+phone.prefix+'-'+phone.number
        });
        return res;
    }

    function setPhones(phone){
        var res = [];
        angular.forEach(phone.split(','), function(splitPhone){
            res.push({
                'prefix': splitPhone.split('-')[0],
                'number': splitPhone.split('-')[1]
            });
        });
        return res;
    }
})();
